
const state = {
	corpId : '',
}

const mutations = {
	setCorpId(state, payload){
		state.corpId = payload;
	}
}

const actions = {
	setCorpId(context, payload){
		context.commit('setCorpId',payload);
	},
}

const getters = {
	getCorpId(state){
		return state.corpId;
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}



// WEBPACK FOOTER //
// ./src/store/modules/corp.js